import { STATUSES } from "../../../util/constants";
import { setStatus, setToDoList } from "../../graphql/slices/todos";
import { getToDoList } from "../enums";

const CONSTANTS = {
  get: getToDoList,
};

const get = `
    ${CONSTANTS.get} {
        todos {
          dueDate
          email
          id
          name
          postDate
          statusCode
          statusDate
          statusName
          summary
          title
          url
          urlLabel
        }
        lastModified
    }
  `;

  const transformResponse = (response = {},  { dispatch }) => {
    const data = response?.data ?? response?.error?.data
    const todoresponse = data?.getToDoList
    try {
      if(todoresponse) {
        dispatch(setToDoList(todoresponse))
      }
      if(response?.error) {
        throw new Error('Unexpected response from to do list')
      }
      return response
      
    } catch (error) {
      console.error(error)
      dispatch(setStatus(STATUSES.ERROR))
      return {
        error: error?.message ?? error
      }
    }

  }

const source = {
  CONSTANTS,
  QUERIES: {
    get,
  },
  transformResponse
}

export default source;
